<template>
  <!-- Vue2 必须唯一根容器 -->
  <div class="tip-root">
    <div v-if="showOrientationTip" class="mask" @click.self="handleClose">
      <div class="panel">
        <!-- 更换为一个简单的手机旋转图标，更直观 -->
        <div class="icon">📱↻</div>
        <p class="text">为了获得最佳体验<br/>请将手机横屏握持浏览</p>
        <button class="btn" @click="handleClose">我知道了</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrientationTip',
  props: {
    showOrientationTip: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClose() {
      // 用户点击后，直接通知父组件关闭即可，不再尝试锁定屏幕
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.tip-root {
  position: fixed;
  inset:0;
  pointer-events:none;
  z-index:1000;
}
.mask {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.72);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events:auto;
}
.panel {
  background: #fff;
  padding: 32px 24px;
  border-radius: 16px;
  text-align: center;
  max-width: 80%;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
}
.icon {
  font-size: 40px;
  margin-bottom: 16px;
  color: #409eff;
}
.text {
  font-size: 16px;
  color: #333;
  margin-bottom: 20px;
  line-height: 1.5;
}
.btn {
  padding: 10px 24px;
  border: none;
  border-radius: 999px;
  background: #409eff;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}
.btn:active {
  opacity: 0.8;
}
</style>